import { useSession } from 'next-auth/react';

import { Heading } from '@/components/heading';
import { DashboardMiniMap } from '@/components/modules/dashboard/mini-map';
import { DashboardQuickLinks } from '@/components/modules/dashboard/quick-links';
import { DashboardSavedRates } from '@/components/modules/dashboard/saved-rates';
import { DashboardSavedRoutes } from '@/components/modules/dashboard/saved-routes';
import { DashboardSavedSchedules } from '@/components/modules/dashboard/saved-schedules';
import { DashboardWelcome } from '@/components/modules/dashboard/welcome';
import { USER_ACCESS_FEATURES } from '@/lib/constants';
import { canAccessFeature } from '@/utils/auth';

const DashboardView = () => {
  const { data: session } = useSession();
  const canAccessTracking = canAccessFeature(USER_ACCESS_FEATURES.TRACKING, session);
  const canAccessRateManagement = canAccessFeature(USER_ACCESS_FEATURES.RATE_MANAGEMENT, session);

  return (
    <div className="overflow-auto">
      <div className="max-w-[1680px] space-y-6 p-2 md:p-6 xl:space-y-8">
        <DashboardWelcome />
        <DashboardQuickLinks />
        <DashboardMiniMap hasTracking={canAccessTracking} />
        <Heading variant="h3" as="h2" className="mb-4">
          Your saved items
        </Heading>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
          <DashboardSavedRoutes />
          <DashboardSavedSchedules />
          {canAccessRateManagement && <DashboardSavedRates />}
        </div>
      </div>
    </div>
  );
};

export { DashboardView };
